<template>
  <div class="yt-chat-list">
    <GridTable
      v-if="stateFilterBySchool"
      ref="gridTable"
      id="ChatList"
      :key="componentKey"
      :title="`${title}${appendTitle || ''}`"
      urlPath="chatMessagesCms"
      :columns="columns"
      :schema="schema"
      :supportAddNew="false"
      :hasEditItem="false"
      :hasDeleteItem="false"
      :defaultServerParams="{
        _sort: 'lastChatDate',
        _order: 'desc',
        schoolId: filteredBySchool
      }"
    >
      <template v-slot:customButtons="slotProps">
        <ModalComponent
          :id="slotProps.props.row.originalIndex"
          width="800"
          :component="modalMessages(slotProps.props.row)"
          >View</ModalComponent
        >
      </template>
    </GridTable>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import BaseList from '@/components/BaseList'

const appModule = namespace('app')

@Component()
export default class ChatList extends BaseList {
  @appModule.State('schools') stateSchools
  @appModule.State('filterBySchool') stateFilterBySchool
  @appModule.State('userProfile') stateUserProfile

  title = 'Chats Messages'

  columns = [
    {
      label: 'ID',
      field: '_id',
      hidden: true
    },
    {
      label: 'School',
      field: 'school.name'
    },
    {
      label: 'Student 1',
      field: rowObj =>
        rowObj.student1 &&
        `${rowObj.student1.firstName} ${rowObj.student1.lastName}`,
      sortable: false
      /* filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Filter by Student', // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                isMultiselect: true,
                fieldNameFilter: 'student1.firstName'
                // filterFn: this.columnFilterFn, // custom filter function that
                // trigger: 'keyup' // only trigger on enter not on keyup
            } */
    },
    {
      label: 'Student 2',
      field: rowObj =>
        rowObj.student2 &&
        `${rowObj.student2.firstName} ${rowObj.student2.lastName}`,
      sortable: false
      /* filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Filter by Student', // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                isMultiselect: true,
                fieldNameFilter: 'student2.firstName'
                // filterFn: this.columnFilterFn, // custom filter function that
                // trigger: 'keyup' // only trigger on enter not on keyup
            } */
    },
    {
      label: 'Sent Date',
      field: rowObj => {
         return (new Date(rowObj.lastChatDate))
      },
      type: 'date',
      dateInputFormat: 'YYYY-MM-DDTHH:mm:ss',
      dateOutputFormat: 'MMM Do YYYY, HH:mm:ss',
      sortable: true
    },
    {
      label: '# Messages',
      field: 'messagesCount',
      type: 'number'
    },
    {
      label: 'Actions',
      field: 'actions',
      sortable: false
    }
  ]

  schema = null

  modalMessages(item) {
    return {
      modalTitle: 'Chat Messages',
      component: () => import('@/components/chats/MessageList'),
      componentProps: {
        item
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/chats/ChatList.vue